import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useSelector } from 'react-redux'
import { setCookies } from '../../../utility/Cookies'
import { encryptCrypto } from '../../../utility/Encryption'

const InteractorAccountChangePassword = () => {
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)
  const accountPasswordVerify = useCallback(
    (payload, callback) => {
      const requestPayload = {
        ...payload,
        uid: account.uid,
      }
      ApiService.jsonRequest('/account-user/verify-password', requestPayload, (response) => {
        if (response.status_code === 200) {
          callback(true)
        } else {
          callback(false)
          showAlert({
            icon: 'error',
            message: t('message.old_password_not_match'),
            reload: true,
            timer: 2000,
          })
        }
      })
    },
    [account.uid, t],
  )

  const accountChangePassword = useCallback(
    (payload, verifyPayload) => {
      ApiService.jsonRequest('/account-user/verify-password', verifyPayload, (response) => {
        if (response.status_code === 200) {
          ApiService.jsonRequest('/account-user/change-password', payload, (response) => {
            if (response.status_code === 200) {
              if (payload?.must_change_password === 'N') {
                // SET NEW COOKIES
                const objAccount = { ...account }
                objAccount.must_change_password = 'N'
                setCookies({
                  key: '_wsso',
                  value: encryptCrypto(JSON.stringify(objAccount)),
                  expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
                })
              }
              showAlert({
                icon: 'success',
                message: t('message.password_change_success'),
                timer: 2000,
                redirect: '/',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t('message.password_change_failed'),
                reload: true,
                timer: 2000,
              })
            }
          })
        } else {
          showAlert({
            icon: 'error',
            message: t('message.old_password_not_match'),
            reload: true,
            timer: 2000,
          })
        }
      })
    },
    [account, t],
  )

  return { accountPasswordVerify, accountChangePassword }
}

export default InteractorAccountChangePassword
